export type DetectedLanguage = "ar" | "en";

/**
 * Respect the visitor's browser preference without inferring language from
 * country, IP address, or any other demographic signal.
 */
export function detectPreferredLanguage(): DetectedLanguage {
  if (typeof navigator === "undefined") return "en";

  const preferences = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  return preferences.some((language) => language.toLowerCase().startsWith("ar"))
    ? "ar"
    : "en";
}
